import { render, staticRenderFns } from "./NoticeUserInfo.vue?vue&type=template&id=bb5b10b6&"
import script from "./NoticeUserInfo.vue?vue&type=script&lang=js&"
export * from "./NoticeUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports